import React, { createContext, useContext, useState } from "react";

interface UserModalContextType {
  isOpen: boolean;
  openUserModal: () => void;
  closeUserModal: () => void;
}

const UserModalContext = createContext<UserModalContextType | undefined>(
  undefined
);

export const UserModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openUserModal = () => setIsOpen(true);
  const closeUserModal = () => setIsOpen(false);

  return (
    <UserModalContext.Provider
      value={{ isOpen, openUserModal, closeUserModal }}
    >
      {children}
    </UserModalContext.Provider>
  );
};

export const useUserModal = () => {
  const context = useContext(UserModalContext);
  if (!context) {
    throw new Error("useUserModal must be used within UserModalProvider");
  }
  return context;
};
